import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { CONFIG } from 'variables/config';

export const useSavedRegions = () => {
    const [savedRegions, setSavedRegions] = useState<string[]>([]);
    const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) return;
        axios
            .get(`${CONFIG.apiUrl}/user/me`, {
                headers: { Authorization: `Bearer ${token}` },
            })
            .then((res) => {
                setSavedRegions(res.data.savedRegions || []);
            })
            .catch(() => {});
    }, []);

    const saveRegions = (regions: string[]) => {
        setSavedRegions(regions);
        if (debounceRef.current) clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => {
            const token = localStorage.getItem('token');
            if (!token) return;
            axios
                .put(
                    `${CONFIG.apiUrl}/user`,
                    { savedRegions: regions },
                    { headers: { Authorization: `Bearer ${token}` } }
                )
                .catch(() => {});
        }, 1000);
    };

    return { savedRegions, saveRegions };
};
